import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {
  Button, Dialog, DialogContent, Typography, TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { IsEmpty } from '../../common/checks';
import useDebounce from '../global/use-debounce';
import apiService from '../../services.js/apiService';
import Util from '../../common/util';

const SelectPageModal = (props) => {
  const [pageList, setPageList] = useState([]);
  const [pageSelected, setPageSelected] = useState(null);
  const [pageNameEntered, setPageNameEntered] = useState(null);
  const [searching, setSearching] = useState(false);
  const debouncedSearch = useDebounce(pageNameEntered, 500);

  const searchPageByName = async (pageName) => {
    try {
      setSearching(true);
      setPageSelected(null);
      const result = await apiService.getPages(pageName, 0, 10);
      const { rows } = result;
      if (!IsEmpty(rows)) {
        setPageList(_.map(rows, (pg) => _.assign({ id: pg.id, name: pg.name })));
      } else {
        setPageList([]);
      }
      Util.Sleep(500).then(() => setSearching(false));
    } catch (err) {
      setSearching(false);
      toast.error(err);
    }
  };

  useEffect(() => {
    searchPageByName(pageNameEntered);
  }, [debouncedSearch]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={props.open}
      >
        <DialogContent>
          <div className="mt-3">
            <Typography variant="h5">Select Page</Typography>
          </div>
          <div className="mt-3 d-flex flex-column">
            <Autocomplete
              options={pageList}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="form-control mb-2"
                  variant="outlined"
                  placeholder="Enter name of page to begin search"
                  onChange={(evt) => {
                    console.log('evt.target.value=', evt.target.value);
                    setPageNameEntered(evt.target.value);
                  }}
                />
              )}
              getOptionLabel={(option) => option.name}
              onChange={(evt, value) => {
                setPageSelected(value);
              }}
            />
          </div>
          <div className="mt-5 mb-4 d-flex flex-row justify-content-end">
            {
              searching && <Typography className="mr-5">searching...</Typography>
            }
            <Button variant="contained" onClick={() => props.onCancel()}>Cancel</Button>
            <Button
              disabled={IsEmpty(pageSelected)}
              className="ml-3"
              variant="contained"
              color="primary"
              onClick={() => props.onSelect(pageSelected.id)}
            >
              Next
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

SelectPageModal.propTypes = {
  open:     PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SelectPageModal;
